(function (app) {

    var AfterpayModel = Backbone.Model.extend({
        defaults: {
            IsAvailable: null,
            Description: null
        },
        initialize: function() {
            _.bindAll(this, '_update');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },
        _update: function(data) {
            this.set(data && data.Afterpay || {});
        }
    });


    app.models = _.extend({ AfterpayModel: new AfterpayModel() }, app.models);
})(app);